


























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiReferencesTypesHierarchy from '@/components/UI/references-types-hierarchy/index.vue';
import ParameterModel from '@/models/parameter-model';
import * as service from '@/services/parameters';
import {
  SCHEDULING_DAYS,
  CANCELLATION_REASON,
  TRANSCRIPTION_APPROVE_PARAM,
  TRANSCRIPTION_MIN_CHECKS,
  PATIENT_CLASSIFICATION_PARAM,
} from '@/settings/consts/parameters-keys';
import { REFERENCE_TYPE_EMEDE } from '@/settings/consts/rules-engine';
import { ERROR_CODE_DUPLICATE } from '@/settings/consts/api-error';
import {
  MESSAGE_PARAMETER_ERROR,
  MESSAGE_PARAMETER_DUPLICATE,
} from '@/settings/consts/messages';
import { errorHandling } from '@/helpers/errorHandling';

@Component({
  components: {
    PermissionAuth,
    UiReferencesTypesHierarchy,
  },
})
export default class ParametersEditModal extends BaseComponent {
  @Prop(ParameterModel)
  public editItem: ParameterModel;
  @Prop({
    default: false,
  })
  public modalOpen: boolean;
  @Prop({
    default: '',
  })
  public modalSize: string;
  @Prop({
    default: true,
  })
  public modalIsFull: boolean;

  public form: any = {
    valid: false,
    rules: {
      clientUnit: [(v) => !!v || 'Selecione uma Unidade'],
      team: [(v) => !!v || 'Selecione um Time'],
      doctor: [(v) => !!v || 'Selecione um Médico'],
    },
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  public item: ParameterModel = new ParameterModel();
  public isOverride: boolean = false;

  @Watch('editItem')
  public onItemChange(val: ParameterModel): void {
    if (!val) {
      return;
    }
    // this.$refs.form.resetValidation();
    this.item = val;
    this.isOverride = this.item.hierarquia !== REFERENCE_TYPE_EMEDE;
  }

  public validateForm(): void {
    this.$refs.form.validate();
  }

  public beforeMount(): void {
    this.onItemChange(this.editItem);
  }

  public saveItem(): void {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }

    this.loader.start('Salvando...');

    const payload = this.item.toJson();
    payload.valores = this.item.valores.map((item) => {
      if (item.isNew) {
        delete item.id;
      }
      return item;
    });

    const onError = (error) => {
      this.loader.stop();

      const errorMessages = {
        default: MESSAGE_PARAMETER_ERROR,
        [ERROR_CODE_DUPLICATE]: MESSAGE_PARAMETER_DUPLICATE,
      };

      const message = errorHandling(error, errorMessages);

      this.toast.show(message, 'error');
    };

    if (!this.item.id) {
      service.saveParameter(payload).subscribe((data) => {
        this.loader.stop();
        this.$emit('close');
        // this.$refs.form.resetValidation();
      }, onError);
    } else {
      service.updateParameter(payload).subscribe((data) => {
        this.loader.stop();
        this.$emit('close');
        // this.$refs.form.resetValidation();
      }, onError);
    }
  }

  public closeForm(): void {
    const closeAction = () => {
      if (!!this.$refs.form) {
        // this.$refs.form.resetValidation();
      }
      this.$emit('close');
    };

    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      closeAction,
    );
  }
}
